import React from 'react'
import WhenDeviceAuthorized from 'support/conditionals/WhenDeviceAuthorized'
import AdminLogin from 'pages/shared/AdminLogin'
import TabletLogin from 'pages/shared/TabletLogin'
import WhenDeviceNotAuthorized from 'support/conditionals/WhenDeviceNotAuthorized'

export default class Login extends React.Component {
  render () {
    return (
      <>
        <WhenDeviceAuthorized>
          <TabletLogin />
        </WhenDeviceAuthorized>

        <WhenDeviceNotAuthorized>
          <AdminLogin />
        </WhenDeviceNotAuthorized>
      </>
    )
  }
}
